module.exports = __webpack_public_path__ + "static/media/livraison_transparent.e63a8d41.png";